import tennis from "../assets/tennis.jpg"
import youtube from "../assets/les-bras-casses.png"

export const sportsContent = [
    {
        name: 'Tennis',
        type: 'Sport',
        image: tennis,
        text1: `I played tennis for over 10 years. I took part in a few competitions but nothing more. 
                I had to stop during the preparatory class but I resumed in the first year of engineering school.`,
        text2: `My best rank is 30/1`
    },
    {
        name: 'The cinema',
        type: 'Other',
        image: youtube,
        text1: `Since secondary school, I've had a passion for cinema. 
                After completing my first video project—a report—I wanted to take things further.`,
        text2: `My friends and I started a YouTube channel called "Les Bras Cassés," where we created 
                short films. This experience gave me hands-on practice with teamwork and film production.`
    },
    {
        name: 'More to come...',
        type: '',
        image: '',
        text1: ``,
        text2: ``
    }
]